import { recipe_default_image } from "../../utils/constants";
export function createRecipeImageArray(recipeImageUrls) {
    const recipeImageList = [];
    if (recipeImageUrls.length > 0) {
        recipeImageUrls.map((ri) => {
            recipeImageList.push(ri.RecipeImage1);
        });
    }
    else {
        recipeImageList.push(recipe_default_image);
    }
    return recipeImageList;
}
